import { buildingQueryKey } from "ApiLayer/Building/queryBuildingModel";
import queryReportPlan from "ApiLayer/CustomPlans/queryReportPlan";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";
import useFiltersetState from "recoilStore/Filters/useFilterset";
import { showMutationAlert } from "utils/helpers";

export interface UpdateCustomPlanData {
    planId: string;
    buildingModelUid: string;
}

export const useReportPlan = () => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const queryClient = useQueryClient();
    const { resetState: resetFiltersetState } = useFiltersetState();

    return useMutation({
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        onSuccess: (_, variables) => {
            alert.success("Recommended plan has been overwritten.");
            queryClient.invalidateQueries([...buildingQueryKey, variables.buildingModelUid]);
            resetFiltersetState();
        },
        mutationFn: async (data: UpdateCustomPlanData) => 
            queryReportPlan(accessToken, {
              planId: data.planId,
        })
    });
}
